import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { getFont, FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { cacheResolver, makeDefaultStylingContext } from '../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const CONTAINER_WIDTH = {
  [HD]: 292,
  [FULL_HD]: 438,
};

export const CONTAINER_HEIGHT = {
  [HD]: 220,
  [FULL_HD]: 300,
};

export const HISTORY_POSITION_X = {
  [HD]: 192,
  [FULL_HD]: 264,
};

export const SEARCHED_ITEM_POSITION_Y = {
  [HD]: 16,
  [FULL_HD]: 32,
};

export const HISTORY_POSITION_Y = {
  [HD]: 424,
  [FULL_HD]: 633,
};

export const EMPTY_HISTORY_LABEL_POSITION = {
  vertical: {
    [HD]: 96,
    [FULL_HD]: 136,
  },
};

export const TITLE_FONT = FONT.KINSHASA_3;

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const EMPTY_HISTORY_FONT = FONT.KINSHASA_3;

export const EMPTY_HISTORY_FONT_TYPE = FONT_TYPE.MAIN;

export const getInitialStyle = ({ screenSize } = defaultContext) => ({
  x: HISTORY_POSITION_X[screenSize],
  y: HISTORY_POSITION_Y[screenSize],
  w: CONTAINER_WIDTH[screenSize],
  h: CONTAINER_HEIGHT[screenSize],
  // Title: {
  //   w: CONTAINER_WIDTH[screenSize],
  //   text: {
  //     ...getFont(TITLE_FONT, screenSize, TITLE_FONT_TYPE),
  //     maxLines: 1,
  //     verticalAlign: 'middle',
  //     textAlign: 'center',
  //   },
  // },
  EmptyHistoryLabel: {
    w: CONTAINER_WIDTH[screenSize],
    y: EMPTY_HISTORY_LABEL_POSITION.vertical[screenSize],
    text: {
      ...getFont(EMPTY_HISTORY_FONT, screenSize, EMPTY_HISTORY_FONT_TYPE),
      maxLines: 3,
      verticalAlign: 'middle',
      textAlign: 'center',
    },
  },
  Items: {
    y: SEARCHED_ITEM_POSITION_Y[screenSize],
    flex: {
      direction: 'column',
      justifyContent: 'center',
    },
  },
  cacheResolver,
});
